import(/* webpackMode: "eager" */ "/codebuild/output/src449371230/src/rmh-platform/apps/rmh-patient/app/error.tsx");
